/* TT Shopify contact -> Klaviyo client event. Native Shopify submission stays in charge. */
(function () {
  'use strict';
  if (window.__ttKlaviyoContactV1) return;
  window.__ttKlaviyoContactV1 = true;

  var KEY = 'tt:klaviyo:contact:v1';
  var MARKER = 'template[data-tt-klaviyo-contact]';
  var TTL = 15 * 60 * 1000;
  var busy = new Set();
  var retries = new Map();

  function notice(status, id) {
    // No email, phone number, message, or API response is logged.
    document.dispatchEvent(new CustomEvent('tt:klaviyo-contact', {
      detail: { status: status, submissionId: id || '' }
    }));
  }

  function readQueue() {
    try {
      var saved = JSON.parse(sessionStorage.getItem(KEY) || '[]');
      if (!Array.isArray(saved)) return [];
      return saved.filter(function (item) {
        return item && typeof item.id === 'string' &&
          typeof item.created === 'number' && item.created <= Date.now() &&
          item.created > Date.now() - TTL && item.company === 'VG2iqb' &&
          typeof item.email === 'string' && item.email.length <= 254 &&
          typeof item.path === 'string' && typeof item.formId === 'string' &&
          item.properties && typeof item.properties === 'object';
      });
    } catch (_) { return []; }
  }

  function saveQueue(items) {
    try {
      if (items.length) sessionStorage.setItem(KEY, JSON.stringify(items));
      else sessionStorage.removeItem(KEY);
      return true;
    } catch (_) {
      notice('storage-unavailable');
      return false;
    }
  }

  function value(form, selector, max) {
    var field = form.querySelector(selector);
    return field ? String(field.value || '').trim().slice(0, max || 1000) : '';
  }

  function capture(event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;
    var marker = form.querySelector(MARKER);
    // An abandoned contact must not be confirmed by a different form's success.
    var queue = readQueue().filter(function (item) { return item.confirmed === true; });
    if (!marker) {
      if (form.querySelector('input[name="form_type"]')) saveQueue(queue);
      return;
    }
    try {
      if (!form.checkValidity() || !form.id) { saveQueue(queue); return; }
      var email = value(form, 'input[name="contact[email]"]', 254);
      if (!email || marker.dataset.companyId !== 'VG2iqb') return;
      var name = value(form, 'input[autocomplete="name"], input[name="contact[name]"]');
      var company = value(form, 'input[autocomplete="organization"], input[name="contact[company]"]');
      var phone = value(form, 'input[type="tel"]');
      var message = value(form, 'textarea[name^="contact["]', 20000);
      var id = 'tt-' + window.crypto.randomUUID();
      var record = {
        id: id, created: Date.now(), confirmed: false,
        company: marker.dataset.companyId, email: email,
        source: marker.dataset.source, section: marker.dataset.sectionId,
        formId: form.id, path: location.pathname,
        properties: {
          'Form source': marker.dataset.source,
          'Form ID': form.id,
          'Page URL': location.origin + location.pathname,
          'Language': document.documentElement.lang || '',
          'Name': name, 'Company': company, 'Phone': phone,
          'Message': message,
          'Message truncated': (form.querySelector('textarea[name^="contact["]')?.value.length || 0) > 20000,
          'Product ID': marker.dataset.productId || '',
          'Product name': marker.dataset.productTitle || ''
        }
      };
      // Keep a bounded tab-only queue; never prevent, replace, or await Shopify's submit.
      if (queue.length >= 10) { notice('queue-full', id); return; }
      queue.push(record);
      if (saveQueue(queue)) notice('awaiting-shopify', id);
    } catch (_) { notice('capture-unavailable'); }
  }

  function confirmShopifySuccess() {
    var queue = readQueue();
    var fragment;
    try { fragment = decodeURIComponent(location.hash.slice(1)); }
    catch (_) { return; }
    queue = queue.filter(function (item) {
      if (item.confirmed || item.path !== location.pathname) return true;
      var markers = Array.from(document.querySelectorAll(MARKER));
      var marker = markers.find(function (candidate) {
        var form = candidate.closest('form');
        return form && form.id === item.formId &&
          candidate.dataset.source === item.source &&
          candidate.dataset.sectionId === item.section;
      });
      if (!marker) return true;
      if (marker.dataset.errors === 'true') return false;
      // Require Shopify's server-rendered success AND the submitted form's return anchor.
      // A query string or button click alone is never treated as successful delivery.
      if (marker.dataset.success === 'true' && fragment === item.formId) {
        item.confirmed = true;
      }
      return true;
    });
    saveQueue(queue);
    queue.filter(function (item) { return item.confirmed; }).forEach(send);
  }

  async function send(item) {
    if (busy.has(item.id) || !item.confirmed) return;
    var count = retries.get(item.id) || 0;
    if (count >= 3) return;
    retries.set(item.id, count + 1);
    busy.add(item.id);
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 12000);
    var retry = false;
    try {
      var profile = { email: item.email };
      // All submitted details belong to this event; do not overwrite existing CRM fields.
      var response = await fetch('https://a.klaviyo.com/client/events?company_id=' + encodeURIComponent(item.company), {
        method: 'POST', mode: 'cors', credentials: 'omit',
        referrerPolicy: 'no-referrer', signal: controller.signal,
        headers: {
          'Content-Type': 'application/vnd.api+json',
          'Accept': 'application/vnd.api+json',
          'revision': '2026-07-15'
        },
        body: JSON.stringify({ data: { type: 'event', attributes: {
          unique_id: item.id,
          time: new Date(item.created).toISOString(),
          metric: { data: { type: 'metric', attributes: { name: 'Submitted TT Contact Form' } } },
          profile: { data: { type: 'profile', attributes: profile } },
          properties: item.properties
        } } })
      });
      if (response.status === 202) {
        saveQueue(readQueue().filter(function (entry) { return entry.id !== item.id; }));
        notice('accepted-by-api', item.id);
      } else {
        retry = response.status === 429 || response.status >= 500;
        notice(retry ? 'retry-pending' : 'api-rejected', item.id);
      }
    } catch (_) {
      retry = true;
      notice('network-unavailable', item.id);
    } finally {
      clearTimeout(timeout);
      busy.delete(item.id);
    }
    if (retry && (retries.get(item.id) || 0) < 3) {
      setTimeout(function () {
        var current = readQueue().find(function (entry) { return entry.id === item.id; });
        if (current) send(current);
      }, count === 0 ? 3000 : 10000);
    }
  }

  document.addEventListener('submit', capture, true);
  window.addEventListener('pageshow', confirmShopifySuccess);
  window.addEventListener('online', confirmShopifySuccess);
  confirmShopifySuccess();
}());
